import React, { useMemo } from 'react';
import type { NewsItem } from '@/types';
import { NewsCard } from './NewsCard';
import { SimpleNewsList } from './SimpleNewsList';
import { AdBanner } from './AdBanner';
import { makeStyles } from '@fluentui/react-components';

interface NewsListProps {
  items: NewsItem[];
  simple?: boolean;
  routineKey?: string;
  dateKey?: string; // 👈 ADD THIS
    onLoginClick: () => void;
}
const useStyles = makeStyles({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', // 4 equal flexible columns
    gap: '10px',
    width: '100%',
    alignItems: 'stretch', // ✅ makes all grid items stretch to the same row height
  },
  headlineWrapper: {
    gridColumn: 'span 3', // occupies exactly 3 columns
    '@media (max-width: 900px)': {
      gridColumn: 'span 4', // full width on tablet
    },
    '@media (max-width: 600px)': {
      gridColumn: 'span 4', // full width on mobile
    },
  },
});
export const NewsList: React.FC<NewsListProps> = ({
  items,
  simple,
  routineKey,
  dateKey,onLoginClick,   // ✅ ADD THIS
}) => {

 const styles = useStyles();
  // ⭐ Find latest headline with image
const { headline, normalItems } = useMemo(() => {
  if (!items || items.length === 0) return { headline: null, normalItems: [] };

  const headlineCandidates = items
    .filter(x => x.IsHeadline && x.imageUrl)
    .sort(
      (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
    );

  const latestHeadline = headlineCandidates[0] || items[0]; // fallback to first if none

  // ⚡ mark it as headline safely
  if (latestHeadline) latestHeadline.IsHeadline = true;

  const rest = items.filter(x => x.id !== latestHeadline?.id);
  return { headline: latestHeadline, normalItems: rest };
}, [items]);
if (simple) {
  return (
    <SimpleNewsList
      items={items}
      routineKey={routineKey}
      dateKey={dateKey} // 👈 PASS THROUGH
    />
  );
}

  return (
    <div>
  {/* Show ad once at the top if enough items */}
  {items.length > 3 && (
    <div style={{ marginBottom: '16px' }}>
      <AdBanner adSlot="1121804425" />
    </div>
  )}
 <div className={styles.grid}>
  {/* Headline First */}
  {headline && (
    <div className={styles.headlineWrapper}>
      <NewsCard
        item={headline}
        // className={styles.headlineCard} // ✅ allow full width
        routineKey={routineKey}
        dateKey={dateKey}
        onLoginClick={onLoginClick}
      />
    </div>
  )}

  {/* Normal News */}
  {normalItems.map(item => (
    <NewsCard
      key={item.id}
      item={item}
      routineKey={routineKey}
      dateKey={dateKey}
      onLoginClick={onLoginClick}
    />
  ))}
</div>

    </div>
  );
};